import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { ViewboxInterviewScheduleEffects } from './viewbox-interview-schedule.effects';

@NgModule({
  imports: [EffectsModule.forFeature([ViewboxInterviewScheduleEffects])],
})
export class ViewboxInterviewScheduleDataModule {}
